import config from './dotenv'

import {Search as WendigSearch} from '@wendig/lib'
import Article from './article'
import Section from './section'
import watchlist from './watchlist'

export default class Search extends WendigSearch {
  constructor() {
    super(config.STATIC_URL + '/database.js')
  }

  articles(criteria = {}) {
    if (criteria['favorites'] !== undefined) {
      delete criteria['favorites']

      criteria['id'] = watchlist.unpack()

      if (criteria['id'].length === 0) {
        criteria['id'] = 'empty'
      }
    }

    criteria['wildcard'] = true

    return this.postMessage({action: 'articles', criteria}).then(data => {
      data['articles'] = data['records'].map(e => new Article(e))

      return data
    })
  }

  article(id) {
    const criteria = {id}
    return this.postMessage({action: 'article', criteria})
  }

  keywords() {
    return this.postMessage({action: 'keywords'})
  }

  people(criteria = {}) {
    return this.postMessage({action: 'people', criteria})
  }

  locations() {
    return this.postMessage({action: 'locations'})
  }

  sections(criteria = {}) {
    return this.postMessage({action: 'sections', criteria}).then(data => {
      data['sections'] = data['records'].map(e => new Section(e))

      return data
    })
  }

  sectionMap() {
    return fetch(`${config.STATIC_URL}/ortsgruppen.json`).then(r => r.json())
  }
}
